import p from 'vue-strict-prop';
import * as tsx from 'vue-tsx-support';
export default tsx.component({
    name: 'exam-session-pill',
    props: {
        /** The label to display. */
        label: p(String).required,
    },
    /** @returns The initial data. */
    data() {
        return {
            tamperCount: 0,
            observer: undefined,
            timer: undefined,
            animation: undefined,
        };
    },
    /** Set up tamper detection after each render. */
    mounted() {
        this.runContinuousAnimation();
        this.startObserver();
        this.timer = setInterval(() => this.restoreIfTampered(), 60_000);
    },
    /** Restart observer after re-render. */
    updated() {
        this.runContinuousAnimation();
        this.startObserver();
    },
    /** Clean up. */
    beforeDestroy() {
        this.animation?.cancel();
        this.observer?.disconnect();
        if (this.timer != null) {
            clearInterval(this.timer);
        }
    },
    methods: {
        /** Restore the pill content if it was tampered with. */
        restoreIfTampered() {
            const el = this.$el;
            if (el instanceof HTMLElement && el.textContent !== this.label) {
                el.textContent = this.label;
            }
        },
        /** Start watching for DOM tampering. */
        startObserver() {
            this.observer?.disconnect();
            this.observer = new MutationObserver(() => {
                this.observer?.disconnect();
                this.restoreIfTampered();
                this.startObserver();
            });
            this.observer.observe(this.$el, {
                childList: true,
                subtree: true,
                characterData: true,
                attributes: true,
            });
        },
        /** Run continuous animation to differentiate from cloned elements. */
        runContinuousAnimation() {
            this.animation?.cancel();
            const el = this.$el;
            if (!(el instanceof HTMLElement)) {
                return;
            }
            // Get the CSS animation and restart it by recreating it via Web Animations API
            // This ensures clones won't have the same animation instance and will be out of sync
            const animations = el.getAnimations();
            animations.forEach(anim => anim.cancel());
            // Recreate the shimmer animation from CSS using Web Animations API
            // This way we control it programmatically - clones won't have this
            this.animation = el.animate([
                { backgroundPosition: '100% 0' },
                { backgroundPosition: '0 100%', offset: 0.5 },
                { backgroundPosition: '100% 0' },
            ], {
                duration: 6000,
                iterations: Infinity,
                easing: 'linear',
            });
        },
    },
    /** @returns The rendered pill. */
    render() {
        return <div class="cg-exam-pill label-medium">{this.label}</div>;
    },
});
